var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Home',{on:{"atualizar":function($event){return _vm.$emit('atualizar')},"alterarDados":function($event){return _vm.$emit('alterarDados')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }